import React from "react";

/**
 * Telegram paper-plane logo as an inline SVG.
 * Uses currentColor so it can be tinted by the parent's text color.
 */
export default function TelegramIcon({ className = "w-5 h-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" focusable="false">
      <path d="M21.94 4.27a1.36 1.36 0 0 0-1.9-.34l-.01.01-15.2 6.05c-.9.36-.86 1.66.06 1.96l3.78 1.23 1.46 5.07c.18.62.95.8 1.39.32l2.14-2.33 3.97 2.92c.52.38 1.26.1 1.4-.52l3.04-13.36c.2-.88-.46-1.52-1.13-1.01zM9.7 13.13l8.36-5.53c.15-.1.31.08.18.2l-6.8 6.27c-.26.24-.43.57-.47.93l-.25 2.04c-.03.27-.41.3-.49.04l-.96-3.27c-.15-.5.06-1.04.43-1.68z" />
    </svg>
  );
}